import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
// Limitless imports
import { logoPng } from "@limitless/images";
const useStyles = makeStyles(theme => ({
  mobileViewContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.background.default,
    backgroundImage: `url(${theme.login.backgroundImg})`
  },
  card: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: 10,
    margin: 10
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    padding: 15
  },
  img: {
    height: 53
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }
}));
const MobileViewMessage = ({
  children,
  showDesktopButton = false,
  desktopButtonAction,
  desktopButtonText = ""
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.mobileViewContainer
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes.card
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.logoContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: logoPng,
    className: classes.img
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.mainContainer
  }, children), showDesktopButton && /*#__PURE__*/React.createElement("div", {
    className: classes.mainContainer
  }, /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    onClick: desktopButtonAction
  }, desktopButtonText))));
};
MobileViewMessage.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]).isRequired,
  showDesktopButton: PropTypes.bool,
  desktopButtonAction: PropTypes.func,
  desktopButtonText: PropTypes.string
};
export default MobileViewMessage;